import { Alert, Paper, Text } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

export function NoBillingAccount() {
  return (
    <Paper withBorder p="xl" radius="md">
      <Alert icon={<IconAlertCircle size={24} />} color="yellow" variant="light" py="sm">
        <Text fw={600} c="yellow.8" size="md">
          Billing Account Setup Issue
        </Text>
        <Text size="sm" c="yellow.8">
          There seems to be a problem with the setup of your billing account.
        </Text>
      </Alert>
      <Text size="sm" ta="center" mt="md">
        Please contact us at{' '}
        <Text component="a" href="mailto:support@sidekickplatform.com" c="blue" td="underline">
          support@sidekickplatform.com
        </Text>{' '}
        for assistance.
      </Text>
    </Paper>
  )
}
